/**
 * Legacy `/ai-studio/bindings` URLs redirect to My instances.
 */

import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const AIStudioBindingsRedirect: React.FC = () => {
  const { bindingId } = useParams<{ bindingId?: string }>();
  if (bindingId) {
    return <Navigate to={`/ai-studio/instances/${bindingId}`} replace />;
  }
  return <Navigate to="/ai-studio/instances" replace />;
};

export default AIStudioBindingsRedirect;
